<!-- 工作台 -->
<template>
  <div id="workbench" class="workbench">
    <div class="status-ctn">
      <div class="status-base" :class="stateRes"></div>
      <el-button size="mini" type="primary" @click="connect">{{status}}</el-button>
    </div>
    <div class="workbench-top">
      <!-- <clientList @chatWith="chatWith" @leaveWith="leaveWith"  ref="clientList"></clientList> -->
      <clientList @addCustomerToChattingList="addCustomerToChattingList" ref="clientList"></clientList>
    </div>
    <div class="workbench-bottom">
      <div>
        <!-- <conversation @chatWith="chatWith" @stopChat="stopChat" ref="conversation"></conversation> -->
        <conversation
          @uploadChatList="uploadChatList"
          @uploadTodayVisitorsList="uploadTodayVisitorsList"
          ref="conversation"
        ></conversation>
      </div>
      <div>
        <!-- <chat ref="chat" @uploadChatList="uploadChatList" @endChat="endChat"></chat> -->
        <chat ref="chat" @uploadChatList="uploadChatList" @createRReservations="createRReservations" @hideHistory="hideHistory"></chat>
      </div>
      <div>
        <dailyOperation
          @tansDailyWord="sendDailyWord"
          @showClientDetail="showClientDetail"
          ref="dailyOperation"
        ></dailyOperation>
      </div>
    </div>
  </div>
</template>
<script>
import clientList from "@/components/workbench/clientList.vue";
import conversation from "@/components/workbench/conversation.vue";
import dailyOperation from "@/components/workbench/dailyOperation.vue";
import chat from "@/components/workbench/chat.vue";
import mixin from  '@/mixins/mixin'
export default {
  mixins: [mixin],
  name: "workbench",
  components: {
    clientList,
    conversation,
    dailyOperation,
    chat
  },
  data() {
    return {
      stateRes: {
        stateli: true,
        state200: false,
        state500: false
      },
      status: "点击上线"
    };
  },
  mounted() {
    this.getLoginUser();
  },
  activated() {
    this.checkRoot();
  },
  computed: {
    // socket 状态
    socketStatus() {
      return this.$store.state.connectState;
    }
  },
  watch: {
    socketStatus(value) {
      // 客服主动下线或 还未上线
      if (value == 0) {
        this.status = "点击上线";
        this.stateRes = {
          stateli: true,
          state200: false,
          state500: false
        };
        this.$message({
          message: "已下线",
          type: "success"
        });
      }
      // 连接中
      if (value == 1) {
        this.status = "连接中...";
        this.contentSocket();
      }
      // value == 2 连接成功
      else if (value == 2) {
        this.status = "连接成功";
        this.stateRes = {
          stateli: false,
          state200: true,
          state500: false
        };
        this.$message({
          message: "已连接到客服服务",
          type: "success"
        });
      }
      // 连接失败
      else if (value == 5) {
        this.status = "点击重连";
        this.stateRes = {
          stateli: false,
          state200: false,
          state500: true
        };
        this.$message.error("连接失败，请点击重新连接");
      }
    }
  },
  methods: {
    // 隐藏访问历史
    hideHistory(){
      this.$refs.clientList.hideHistory();
    },
    // 判断根路由指向
    checkRoot() {
      let tree = this.$util.getSessionStorage("root");
      if (tree) {
        let menu = this.$util.getNode("客服系统", 1);
        this.menu = menu;
        let haveWorkbench = true;
        let businessUrl = "";
        for (let i = 0; i < menu.length; i++) {
          if (menu[i].Name == "工作台") {
            haveWorkbench = true;
          }
          if (menu[i].Name == "业务管理") {
            businessUrl = menu[i].Url;
          }
        }
        if (!haveWorkbench) {
          this.$router.push(businessUrl);
        }
      }
    },
    // 通知连接socket
    connect() {
      if (this.socketStatus == 2) {
        return;
      }
      this.$store.commit("updateConnectState", 1);
    },
    // 获取当前登录客服的信息
    getLoginUser() {
      let token = this.$util.getUrlParam("Token")
        ? this.$util.getUrlParam("Token")
        : this.$util.default_token;
      if (token) {
        localStorage.setItem("token", token);
        document.cookie = "Token=" + token;
      } else {
        token = localStorage.getItem("token");
      }

      if (!token) {
        this.$message({
          message: "请先登录",
          type: "warning"
        });
        setTimeout(() => {
          // window.location.href='http://eip.chehuijia.com.cn/Login/Index'
        }, 2000);
        return;
      }
      this.axios
        .get("/Common/GetCurrentUser", {
          params: {
            token: token
          }
        })
        .then(response => {
          if (response.data.errcode == 0) {
            let data = response.data.data;
            this.userMsg = data;
            this.$util.setSessionStorage("userMsg", data);
            this.$store.commit("updateUserMsg", data);
            this.$refs.dailyOperation.init();
          } else if (response.data.errcode == 500) {
            this.$message({
              message: "请先登录",
              type: "warning"
            });
            setTimeout(() => {
              // window.location.href='http://eip.chehuijia.com.cn/Login/Index'
            }, 2000);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 连接websocket
    contentSocket() {
      let that = this;
      let id = this.$store.state.userMsg.Id
        ? this.$store.state.userMsg.Id
        : "49df1602-f5f3-4d52-afb7-3802da61955";
      this.$util.initWebSocket(id).then(() => {
        this.$util.receiveWebsocket(massage => {
          let nowChatId;
          let nowChat;
          let uId;
          let reload;
          let audio = document.createElement("AUDIO");
          audio.src =`${this.$util.QN_URL_BASE}UploadFile/Commons/Public/Mp3/ChatAudio.mp3`;
          switch (massage.type) {
            // 连接事件，包括客服与客户
            case "onConnect":
              this.connectResponse(massage.result);
              break;
            //  客户上线事件
            case "C_OnLine":
              this.$refs.conversation.GetChattingList(massage.result);
              this.$refs.clientList.GetTodayVisitorsList();
              break;
            //  客户离线事件
            case "C_Offline":
               nowChat = that.$store.state.customerMsg;
              if (massage.result == nowChat.uId) {
                nowChat.isLeave = true;
                this.$store.commit("updateCustomerMsg", nowChat);
              }
              this.$refs.conversation.GetChattingList();
              this.$refs.clientList.GetTodayVisitorsList();
              break;
            //  接收聊天信息
            case "ReceiveMsg":
              audio.play();
              // 判断是不是当前正在聊天的客服的消息，是就给chat组件，不是就给conversation
              nowChatId = that.$store.state.customerMsg.uId;
              uId = massage.result.sender;
              reload = massage.result.reload;
              // 是否将客户重新加载到对话列表
              if (reload) {
                this.$refs.conversation.addCustomerToChattingList(uId, false);
                this.$refs.conversation.updateNoRead(massage.result);
                return;
              }
              if (uId == nowChatId) {
                this.$refs.chat.receiveChatMsg(massage.result);
              } else {
                this.$refs.conversation.updateNoRead(massage.result);
              }
              break;
            //  消息已读通知,返回接收人id
            case "ReadNotice":
              nowChatId = that.$store.state.customerMsg.uId;
              uId = massage.result;
              if (nowChatId == uId) {
                this.$refs.chat.markRead();
              }
              break;
          }
        });
      });
    },
    // 连接socket 结果反馈
    connectResponse(result) {
      if (result.connState == 0) {
        // console.log("socket连接成功");
        this.$refs.clientList.GetTodayVisitorsList();
        this.$refs.conversation.GetChattingList(result);
        this.$store.commit("updateConnectState", 2);
      } else {
        this.$store.commit("updateConnectState", 5);
      }
    },
    // 常用语传递到聊天组件
    sendDailyWord(res) {
      this.$refs.chat.getDailyWords(res);
    },
    //添加客户到对话列表
    addCustomerToChattingList(data) {
      this.$refs.conversation.addCustomerToChattingList(data.Uid);
    },
    //更新今日访客与对话列表
    uploadChatList(data) {
      this.$refs.conversation.GetChattingList();
      this.$refs.clientList.GetTodayVisitorsList();
    },
    //更新今日访客列表
    uploadTodayVisitorsList() {
      this.$refs.clientList.GetTodayVisitorsList();
    },
    // // 聊天组件中结束对话
    // endChat (){
    //     this.$refs.clientList.GetTodayVisitorsList()
    //     this.$refs.conversation.GetChattingList();
    // },
    // 和当前客户停止聊天,更新今天访客与聊天组件中的聊天客户,未使用
    stopChat(item) {
      this.$refs.clientList.GetTodayVisitorsList();
      this.$refs.chat.stopChatFromList(item);
    },
    // 聊天的人的信息传递到聊天组件和操作组件，未使用
    chatWith(data) {
      if (data.Uid) {
        this.$refs.conversation.addCustomerToChattingList(data.Uid);
        //更新今日访客与对话列表
        this.uploadChatList();
        return;
      }
      this.$refs.chat.getkhMsg(data);
      this.$refs.dailyOperation.getkhMsg(data);
    },

    // 留言人信息传递到聊天组件，未使用
    leaveWith(data) {
      // this.$refs.conversation.addCustomerToChattingList(data.Uid);
      this.$refs.chat.leaveWith(data);
      this.$refs.dailyOperation.getkhMsg(data);
    },

    // 获取服务端推送消息
    getPush(message) {
      this.$notify({
        title: "提示",
        message: "您有一条新的客服转接消息",
        duration: 0
      });
    },
    //查看客户详情
    showClientDetail(data) {
      this.$refs.clientList.showClientDetail(data);
    },
    //创建维修预约
    createRReservations(cid,entpId) {
      this.$refs.clientList.openReservarion(cid,entpId);
    }
  }
};
</script>
<style lang="less" scoped>
.status-ctn {
  position: absolute;
  top: 16px;
  right: 170px;
  display: flex;
  align-items: center;
}
.status-base {
  margin: 0 10px 0 20px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
}
.workbench {
  display: flex;
  flex-direction: column;
  height: calc(100% - 61px) !important;
}
.workbench-bottom {
  display: flex;
  flex-grow: 1;
  > div:nth-child(1) {
    width: 20%;
    border-right: 1px solid @border1Color;
  }
  > div:nth-child(2) {
    width: 50%;
  }
  > div:nth-child(3) {
    width: 30%;
    border-left: 1px solid @border1Color;
  }
}
.stateli {
  background: gainsboro;
}
.state200 {
  background: greenyellow;
}
.state500 {
  background: red;
}
</style>
